// extracted by mini-css-extract-plugin
module.exports = {"tooltipText":"tooltips_tooltipText__Kg5Ul"};